import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { stockKeys } from "./query-keys";

export function useDeleteSKU() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (sku: string) => {
      const { error } = await apiClient.DELETE("/v1/sku/{sku}", {
        params: { path: { sku } },
      });
      if (error) throw error;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: stockKeys.all });
    },
  });
}
